import {
  PHONE_MEDIA_QUERY,
  TABLET_MEDIA_QUERY,
} from '../components/breakpoints'

const imgSizeGenerator = (
  phone: number | null | undefined,
  tablet: number | null | undefined,
  fallback: number,
): string => {
  const sizes: string[] = []

  if (phone) {
    sizes.push(`${PHONE_MEDIA_QUERY} ${phone}px`)
  }

  if (tablet) {
    sizes.push(`${TABLET_MEDIA_QUERY} ${tablet}px`)
  }

  sizes.push(`${fallback}px`)
  return sizes.join(', ')
}

export const cardImgSizes = imgSizeGenerator(400, null, 500)

export default imgSizeGenerator
